import * as React from "react"
import { Box, Typography } from "@mui/material"
import ProjectCamera from "../components/streaming/ProjectCamera"

export default function Project() {
  return (
    <Box>
      <Box sx={{ mb: 3 }}>
        <Typography variant="h3">Project Mode</Typography>
        <Typography variant="subtitle1">
          Compute homography for wall projection mapping
        </Typography>
      </Box>
      <ProjectCamera />
    </Box>
  )
}
